<script lang="ts">
    import { _, t } from "svelte-i18n"
    import { onMount } from "svelte"
    // dont import index.js, because node process dependency (not avail in tibi-server)
    // @ts-ignore
    import { loadScript } from "@paypal/paypal-js/dist/esm/paypal-js"
    import type { loadScript as loadScriptT } from "@paypal/paypal-js"

    import { cart, checkoutData, getAsyncCartSum } from "../../../store"
    import { postPayment } from "../../../api"
    import {
        currency,
        paypalLiveClientId,
        paypalMode,
        paypalSandboxClientId,
    } from "../../../../../api/hooks/config-client"
    import MiniLoader from "../../widgets/MiniLoader.svelte"

    export let submitHandler: () => Promise<void>

    let ppContainer: HTMLElement

    let initialized = false

    const paypalLoadScript = loadScript as typeof loadScriptT

    if (typeof window !== "undefined") {
        onMount(async () => {
            const paypal = await paypalLoadScript({
                clientId: paypalMode == "sandbox" ? paypalSandboxClientId : paypalLiveClientId,
                currency: currency.code,
            })

            initialized = true
            ppContainer.innerHTML = ""

            const cartSum = await getAsyncCartSum($cart)

            paypal
                .Buttons({
                    // Order is created on the server and the order id is returned
                    createOrder: (data, actions) => {
                        return postPayment({
                            type: "paypal",
                            cart: $cart,
                            sum: cartSum,
                            vat: $checkoutData.vat,
                            contact: $checkoutData.contact,
                            billingAddress: $checkoutData.billingAddress,
                            deliveryAddress: $checkoutData.deliveryAddress,
                        }).then((response) => {
                            console.log("PAYPAL ORDER:", response)
                            return response.pay_id
                        })
                    },
                    // Finalize the transaction on the server after payer approval
                    onApprove: (data, actions) => {
                        $checkoutData.payment.pay_id = data.orderID
                        return submitHandler()
                    },
                })
                .render("#paypal-button-container")
        })
    }
</script>

<div id="pp">
    <h4>{$_("paypal.order_now")}:</h4>
    {#if !initialized}<MiniLoader />{/if}
    <div bind:this="{ppContainer}" id="paypal-button-container"></div>
</div>

<style>
    #pp {
        width: 400px;
        max-width: 100%;
    }
</style>
